import * as React from "react";
import type { SVGProps } from "react";

const SvgPdf = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={16}
        height={16}
        viewBox="0 0 24 26"
        {...props}
    >
        <path
            fill="#004E86"
            d="M4 10h10v2H4Zm7.414-10L18 6.586V14h5a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V2C0 .448.448 0 2 0h9.414ZM21.5 15.98h-5.229v7.82h1.885v-3.115H21.2v-1.45h-3.04v-1.8h3.34Zm-9.824 0H9.16v7.82h2.573a3.624 3.624 0 0 0 1.84-.486 3.318 3.318 0 0 0 1.278-1.332 4.029 4.029 0 0 0 .454-1.926V19.7a4.005 4.005 0 0 0-.47-1.92 3.3 3.3 0 0 0-1.292-1.327 3.706 3.706 0 0 0-1.864-.47Zm-6.558 0H2v7.82h1.885v-2.653h1.2a3.4 3.4 0 0 0 2.248-.685 2.263 2.263 0 0 0 .819-1.829 2.567 2.567 0 0 0-.379-1.383 2.489 2.489 0 0 0-1.069-.94 3.635 3.635 0 0 0-1.587-.33Zm6.558 1.456a1.492 1.492 0 0 1 1.268.575 2.806 2.806 0 0 1 .435 1.708v.338a2.829 2.829 0 0 1-.435 1.716 1.467 1.467 0 0 1-1.246.577h-.655v-4.915Zm-6.537 0a1.046 1.046 0 0 1 .806.333 1.258 1.258 0 0 1 .3.875 1.018 1.018 0 0 1-.287.773 1.165 1.165 0 0 1-.835.274H3.885v-2.256ZM10 2H2v12h14V8h-6Zm2 1.415V6h2.585Z"
        />
    </svg>
);
export default SvgPdf;
